import Loading from '@/common/components/atom/loading';
import type { SVGProps } from 'react';

export type Icon14IconProps = SVGProps<SVGSVGElement> & { title?: string };

// Keep existing imports and layout classes while sharing the patient loading indicator.
export function Icon14Icon(props: Icon14IconProps) {
  return <Loading width="1em" height="1em" {...props} />;
}

export default Icon14Icon;
